import { Component, ChangeDetectionStrategy } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-gestion-usuarios-resumen',
  templateUrl: './gestion-usuarios-resumen.component.html',
  styleUrl: './gestion-usuarios-resumen.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class GestionUsuariosResumenComponent {}
